export const labels = {
	mapStyleTitle: {
		label: "Label.MobileCreator.Maps.Dialog.Style",
		default: "Map style",
	},
	pinStyleTitle: {
		label: "Label.MobileCreator.Maps.Dialog.PinStyle",
		default: "Pin style",
	},
	copyCoordinatesToClipboard: {
		label: "Label.MobileCreator.Maps.Dialog.CopyCoordinates",
		default: "copied coordinates to clipboard",
	},
} as const;
